
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class QryMasterDialog extends Serenity.EntityDialog<QryMasterRow, any> {
        protected getFormKey() { return QryMasterForm.formKey; }
        protected getIdProperty() { return QryMasterRow.idProperty; }
        protected getLocalTextPrefix() { return QryMasterRow.localTextPrefix; }
        protected getNameProperty() { return QryMasterRow.nameProperty; }
        protected getService() { return QryMasterService.baseUrl; }
        protected getDeletePermission() { return QryMasterRow.deletePermission; }
        protected getInsertPermission() { return QryMasterRow.insertPermission; }
        protected getUpdatePermission() { return QryMasterRow.updatePermission; }

        protected form = new QryMasterForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.push(
                {
                    title: Q.text(" Continue"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-report',
                    icon: 'fa fa-check text-green',
                    onClick: () => {
                        this.save((response) => {
                                                  
                           
                        let url = "/Product/SkuHd";
                        window.location.href = url;
                        });
                        
                        //window.open(url, '_blank');
                        // *** do something on click if you want **

                    },
                }
            );

            buttons.push(
                {
                    title: Q.text("Add New สินค้า"),	// *** Get button text from translation
                    cssClass: 'add-new-item',
                    icon: 'fa fa-plus text-green',
                    onClick: () => {
                        this.save((response) => {
                            // this.dialogClose();
                        
                           
                        let url = "/Product/SkuHd#new";
                        window.location.href = url;
                        });
                        
                       
                    },
                }
            );
            buttons.push(
                {
                    title: Q.text(""),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa fa-close text-red',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
       
           
       
            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }
       
                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            self.element.find(".panel-titlebar").html("Master Sku Filter");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                             self.element.parent().find(".panel-titlebar").html("Master Sku Filter");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                           // self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            
        }

    }
}